"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPriceRatio = void 0;
const caip_1 = require("@shapeshiftoss/caip");
const api_1 = require("../../../../api");
const bignumber_1 = require("../../../utils/bignumber");
const isRune_1 = require("../isRune/isRune");
const thorService_1 = require("../thorService");
const getPriceRatio = async (deps, input) => {
    const { buyAssetId, sellAssetId } = input;
    try {
        const buyPoolId = caip_1.adapters.assetIdToPoolAssetId({ assetId: buyAssetId });
        const sellPoolId = caip_1.adapters.assetIdToPoolAssetId({ assetId: sellAssetId });
        if (!buyPoolId && !(0, isRune_1.isRune)(buyAssetId)) {
            throw new api_1.SwapError(`[getPriceRatio]: No buyPoolId found for asset ${buyAssetId}`, {
                code: api_1.SwapErrorTypes.POOL_NOT_FOUND,
                fn: 'getPriceRatio',
                details: { buyAssetId },
            });
        }
        if (!sellPoolId && !(0, isRune_1.isRune)(sellAssetId)) {
            throw new api_1.SwapError(`[getPriceRatio]: No sellPoolId found for asset ${sellAssetId}`, {
                code: api_1.SwapErrorTypes.POOL_NOT_FOUND,
                fn: 'getPriceRatio',
                details: { sellAssetId },
            });
        }
        const { data: responseData } = await thorService_1.thorService.get(`${deps.daemonUrl}/lcd/thorchain/pools`);
        const buyPool = responseData.find((response) => response.asset === buyPoolId);
        const sellPool = responseData.find((response) => response.asset === sellPoolId);
        /**
         * there is no rune pool, rune *is* the pool, special logic case buying RUNE
         */
        if ((0, isRune_1.isRune)(buyAssetId) && sellPool) {
            const sellAssetBalance = (0, bignumber_1.bnOrZero)(sellPool.balance_asset);
            const runeBalance = (0, bignumber_1.bnOrZero)(sellPool.balance_rune);
            // guard against division by zero
            if (sellAssetBalance.eq(0))
                throw new api_1.SwapError(`[getPriceRatio] zero sell asset balance sellAssetId ${sellAssetId} buyAssetId ${buyAssetId}`);
            return (0, bignumber_1.bn)(runeBalance).dividedBy(sellAssetBalance).toString();
        }
        if ((0, isRune_1.isRune)(sellAssetId) && buyPool) {
            const buyAssetBalance = (0, bignumber_1.bnOrZero)(buyPool.balance_asset);
            const runeBalance = (0, bignumber_1.bnOrZero)(buyPool.balance_rune);
            // guard against division by zero
            if (buyAssetBalance.eq(0))
                throw new api_1.SwapError(`[getPriceRatio] zero buy asset balance sellAssetId ${sellAssetId} buyAssetId ${buyAssetId}`);
            return (0, bignumber_1.bn)(buyAssetBalance).dividedBy(runeBalance).toString();
        }
        if (!buyPool || !sellPool) {
            throw new api_1.SwapError(`[getPriceRatio]: pools not found`, {
                code: api_1.SwapErrorTypes.RESPONSE_ERROR,
                details: { buyPoolId, sellPoolId },
            });
        }
        const buyPrice = (0, bignumber_1.bn)(buyPool.balance_rune).dividedBy(buyPool.balance_asset);
        const sellPrice = (0, bignumber_1.bn)(sellPool.balance_rune).dividedBy(sellPool.balance_asset);
        if (!buyPrice.gt(0) || !sellPrice.gt(0)) {
            throw new api_1.SwapError(`[getPriceRatio]: invalid pool price`, {
                code: api_1.SwapErrorTypes.RESPONSE_ERROR,
                details: { buyPrice, sellPrice },
            });
        }
        return sellPrice.dividedBy(buyPrice).toString();
    }
    catch (e) {
        if (e instanceof api_1.SwapError)
            throw e;
        throw new api_1.SwapError('[getPriceRatio]: Thorchain getPriceRatio failed', {
            code: api_1.SwapErrorTypes.PRICE_RATIO_FAILED,
            cause: e,
        });
    }
};
exports.getPriceRatio = getPriceRatio;
